import { createFileRoute } from "@tanstack/react-router";

import { LongTermLiabilities } from "~/components/feature/balance/components";

export const Route = createFileRoute(
  "/_app/dashboard/balance/long-term-liabilities/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <LongTermLiabilities />;
}
